import React, {useState} from 'react';

import {ModalComponentProps, Dialog, DialogBody, Card, DateInput, DialogFooter, Button, Label, Row, Col, Block} from '@mc/ui-v4';
import {FeatureFilter} from '@mc/react-mapio';

type Props = ModalComponentProps & {
    title: string;
    initialValues?: FeatureFilter;
    onSubmit: (date: FeatureFilter) => void;
    dateRange?: boolean;
};

/**
 * Modal na výběr data pro filtraci dat vrstev.
 * @param onClose - Funkce pro zavření modálního okna.
 * @param onSubmit - Funkce pro odeslání dat.
 * @param title - Název modálního okna.
 * @param initialValues - Počáteční hodnota.
 * @param dateRange - Určuje, zda se má vybírat rozsah dat.
 */
export const DatePickerModal: React.FC<Props> = ({onClose, onSubmit, title, initialValues, dateRange = true}) => {
    const [dateFrom, setdateFrom] = useState<string>((initialValues?.dateFrom || new Date()).toISOString().split('T')[0]);
    const [dateTo, setdateTo] = useState<string>((initialValues?.dateTo || new Date()).toISOString().split('T')[0]);
    return (
        <Dialog size={'sm'} onClose={onClose} title={title}>
            <DialogBody>
                <Card mode={'edit'}>
                    <Block>
                        <Row>
                            {dateRange ? (
                                <>
                                    <Col>
                                        <Label>Od</Label>
                                        <DateInput fullWidth value={dateFrom || ''} onChange={val => setdateFrom(val ? val.split('T')[0] : null)} />
                                    </Col>
                                    <Col>
                                        <Label>Do</Label>
                                        <DateInput fullWidth value={dateTo || ''} onChange={val => setdateTo(val ? val.split('T')[0] : null)} />
                                    </Col>
                                </>
                            ) : (
                                <Col>
                                    <Label>Vyberte datum</Label>
                                    <DateInput fullWidth value={dateFrom || ''} onChange={val => setdateFrom(val ? val.split('T')[0] : null)} />
                                </Col>
                            )}
                        </Row>
                    </Block>
                </Card>
            </DialogBody>
            <DialogFooter>
                <Button onClick={onClose} style={'link'}>
                    Zrušit
                </Button>
                <Button
                    style="primary"
                    onClick={() => onSubmit(dateRange ? {dateFrom: new Date(dateFrom), dateTo: new Date(dateTo)} : {date: new Date(dateFrom)})}
                    type={'submit'}
                >
                    Zobrazit
                </Button>
            </DialogFooter>
        </Dialog>
    );
};
